import React, { useState, useEffect, useRef } from "react";
import SteppedNumberInput from "../../../Reusable/NumberInputs/SteppedNumberInput";

function WorldValueInput(props) {
  const [inputValue, setInputValue] = useState("");
  const [lastValidValue, setLastValidValue] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    // Sync state with props value - support decimals unlike original ValueInput
    if (props.value !== inputValue) {
      const newValue = props.value !== undefined ? String(props.value) : "";
      setInputValue(newValue);
      setLastValidValue(newValue);
    }
  }, [props.value]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;

    // Allow "-", ".", or empty string for user input
    if (newValue === "-" || newValue === "" || newValue === ".") {
      setInputValue(newValue);
      return;
    }

    const numberValue = Number(newValue);

    // Update state only if the input is a valid number
    if (!isNaN(numberValue)) {
      setInputValue(newValue);

      // ADD THIS: Update the 3D scene immediately on valid input
      if (typeof props.handleUpdate === "function") {
        if (props.valueKey) {
          props.handleUpdate(props.valueKey, numberValue);
        } else {
          props.handleUpdate(numberValue);
        }
      }
    }
  };

  const handleBlur = () => {
    // Revert to last valid value if input is empty or invalid
    if (inputValue === "" || inputValue === "-" || inputValue === ".") {
      setInputValue(lastValidValue);
    } else {
      setLastValidValue(inputValue);
      if (typeof props.handleUpdate === "function") {
        if (props.valueKey) {
          props.handleUpdate(props.valueKey, Number(inputValue));
        } else {
          props.handleUpdate(Number(inputValue));
        }
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      // Submit value on Enter
      if (inputValue !== "" && inputValue !== "-" && inputValue !== "." && typeof props.handleUpdate === "function") {
        if (props.valueKey) {
          props.handleUpdate(props.valueKey, Number(inputValue));
        } else {
          props.handleUpdate(Number(inputValue));
        }
        setLastValidValue(inputValue);
      } else {
        setInputValue(lastValidValue);
      }

      if (inputRef.current) {
        inputRef.current.blur();
      }
    }
  };

  const tooltip = props.tooltip || props.name;
  const labelTitle = props.tooltip ? `${props.name}: ${props.tooltip}` : props.name;

  return (
    <div className="WorldValueInputWrapper" style={{ marginTop: props.marginTop || "10px" }} title={tooltip}>
      <label className="WorldValueInputLabel" style={{ width: props.paddingWidth }} title={labelTitle}>
        {props.name}
      </label>
      <SteppedNumberInput
        ref={inputRef}
        step={props.step}
        max={props.max}
        min={props.min}
        className="WorldValueInput"
        style={{ width: props.inputWidth || "45px" }}
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        title={tooltip}
        aria-label={labelTitle}
      />
    </div>
  );
}

export default WorldValueInput;
